if (!customElements.get('el-accordion-cards')) {
  customElements.define(
    'el-accordion-cards',
    class ElAccordionCards extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.media = window.matchMedia('(max-width: 980px)');
        this.featuresSlider = this.querySelector('[data-el-features-swiper]');
        this.featuresSwiper = null;
        this.interactiveImageWrap = this.querySelector('.el-accordion-cards__interactive-image-wrap');

        this.handleClick = this.handleClick.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);

        this.addEventListener('click', this.handleClick);
        this.media.addEventListener('change', this.handleMediaChange);

        this.handleMediaChange();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);

        if (this.media) {
          this.media.removeEventListener('change', this.handleMediaChange);
        }

        this.destroyFeaturesSwiper();
      }

      handleClick(event) {
        const pointButton = event.target.closest('[data-el-point-button]');
        const pointClose = event.target.closest('[data-el-point-close]');
        const mobileSheet = event.target.closest('[data-el-mobile-sheet]');
        const cardToggle = event.target.closest('[data-el-card-toggle]');
        const cardClose = event.target.closest('[data-el-card-close]');

        if (pointButton) {
          this.openPoint(pointButton.dataset.pointId);
          return;
        }

        if (pointClose || event.target === mobileSheet) {
          this.closePoint();
          return;
        }

        if (cardToggle) {
          this.toggleCard(cardToggle);
          return;
        }

        if (cardClose) {
          const card = cardClose.closest('[data-el-card]');
          this.closeCard(card);
        }
      }

      openPoint(pointId) {
        const template = [...this.querySelectorAll('[data-el-point-template]')].find(
          (item) => item.dataset.elPointTemplate === pointId
        );

        const desktopPanel = this.querySelector('[data-el-point-panel]');
        const mobileSheet = this.querySelector('[data-el-mobile-sheet]');
        const mobileSheetInner = this.querySelector('[data-el-mobile-sheet-inner]');

        if (!template || !desktopPanel || !mobileSheet || !mobileSheetInner) return;

        if (this.interactiveImageWrap) {
          this.interactiveImageWrap.classList.add('is-point-open');
        }

        this.querySelectorAll('[data-el-point-button]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.pointId === pointId);
        });

        if (this.media.matches) {
          desktopPanel.classList.remove('is-active');
          desktopPanel.innerHTML = '';

          mobileSheetInner.innerHTML = template.innerHTML;

          requestAnimationFrame(() => {
            mobileSheet.classList.add('is-active');
            document.documentElement.classList.add('el-accordion-cards-sheet-open');
          });
        } else {
          mobileSheet.classList.remove('is-active');
          mobileSheetInner.innerHTML = '';

          desktopPanel.classList.remove('is-active');
          desktopPanel.innerHTML = template.innerHTML;

          requestAnimationFrame(() => {
            desktopPanel.classList.add('is-active');
          });
        }
      }

      closePoint() {
        const desktopPanel = this.querySelector('[data-el-point-panel]');
        const mobileSheet = this.querySelector('[data-el-mobile-sheet]');
        const mobileSheetInner = this.querySelector('[data-el-mobile-sheet-inner]');

        if (this.interactiveImageWrap) {
          this.interactiveImageWrap.classList.remove('is-point-open');
        }

        this.querySelectorAll('[data-el-point-button]').forEach((button) => {
          button.classList.remove('is-active');
        });

        if (desktopPanel) {
          desktopPanel.classList.remove('is-active');

          setTimeout(() => {
            if (!desktopPanel.classList.contains('is-active')) {
              desktopPanel.innerHTML = '';
            }
          }, 350);
        }

        if (mobileSheet) {
          mobileSheet.classList.remove('is-active');
        }

        if (mobileSheetInner) {
          setTimeout(() => {
            if (mobileSheet && !mobileSheet.classList.contains('is-active')) {
              mobileSheetInner.innerHTML = '';
            }
          }, 350);
        }

        document.documentElement.classList.remove('el-accordion-cards-sheet-open');
      }

      toggleCard(button) {
        const card = button.closest('[data-el-card]');
        if (!card) return;

        const willOpen = !card.classList.contains('is-active');

        this.querySelectorAll('[data-el-card]').forEach((item) => {
          this.closeCard(item);
        });

        if (willOpen) {
          card.classList.add('is-active');
          button.setAttribute('aria-expanded', 'true');
        }
      }

      closeCard(card) {
        if (!card) return;

        const button = card.querySelector('[data-el-card-toggle]');

        card.classList.remove('is-active');

        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      }

      handleMediaChange() {
        this.closePoint();

        if (this.media.matches) {
          this.initFeaturesSwiper();
        } else {
          this.destroyFeaturesSwiper();
        }
      }

      initFeaturesSwiper() {
        if (this.featuresSwiper || !this.featuresSlider) return;

        if (typeof Swiper === 'undefined') {
          setTimeout(() => this.initFeaturesSwiper(), 100);
          return;
        }

        this.featuresSwiper = new Swiper(this.featuresSlider, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          speed: 500,
          watchOverflow: true,
          grabCursor: true,
          breakpoints: {
            0: {
                slidesPerView: '1.24',
                spaceBetween: 16
            },
            480: {
                slidesPerView: '1.5',
                spaceBetween: 20
            },
            768: {
                slidesPerView: '2',
                spaceBetween: 25
            }
          }
        });
      }

      destroyFeaturesSwiper() {
        if (!this.featuresSwiper) return;

        this.featuresSwiper.destroy(true, true);
        this.featuresSwiper = null;
      }
    }
  );
}